import styles from './index.module.scss';
import SVG from 'react-inlinesvg';
import { PowerBy } from '@autopass-web/mochi-component';
import { MochiButton } from '@autopass-web/mochi-component';
import type { MochiButtonProps } from '@autopass-web/mochi-component';

interface ErrorPaymentModuleProps {
  title: string;
  description?: string;
  isPositive?: boolean;
  linkProps?: {
    onClick: () => void;
    theme: MochiButtonProps['theme'];
    content: string;
  };
}

export const ErrorPaymentModule = ({
  title,
  description = '請重新嘗試',
  isPositive = false,
  linkProps,
}: ErrorPaymentModuleProps) => (
  <div className={styles['error']}>
    <div className={styles['content']}>
      {isPositive ? (
        <SVG className={styles['ok']} src="/assets/check-filled.svg" />
      ) : (
        <SVG className={styles['ok']} src="/assets/error-filled.svg" />
      )}
      <div className={styles['title']}>{title}</div>
      <div className={styles['desc']}>{description}</div>
      {!!linkProps && (
        <MochiButton
          style={{ width: '50%' }}
          onClick={linkProps.onClick}
          theme={linkProps.theme || 'blue'}
        >
          {linkProps.content}
        </MochiButton>
      )}
    </div>
    <PowerBy />
  </div>
);
